var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 20,
    width: 16,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    stroke: "#FFF",
    d: "M2.15862 0.58856L2.15939 0.589093L15.1593 9.58904C15.1593 9.58906 15.1594 9.58908 15.1594 9.58909C15.2948 9.68288 15.375 9.83638 15.375 10C15.375 10.1636 15.2947 10.3172 15.1593 10.411L2.16002 19.4105C2.15996 19.4105 2.1599 19.4106 2.15983 19.4106C2.07302 19.4704 1.97428 19.5 1.875 19.5C1.79617 19.5 1.71668 19.4813 1.64259 19.4429C1.47765 19.3561 1.375 19.1859 1.375 19V0.999996C1.375 0.813863 1.47789 0.643474 1.64315 0.556834L1.64315 0.556835L1.64426 0.556251C1.80635 0.47076 2.00637 0.48273 2.15862 0.58856ZM3.1596 2.49789L2.375 1.95474V2.909V17.091V18.0453L3.1596 17.5021L13.4026 10.4111L13.9964 10L13.4026 9.58889L3.1596 2.49789Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTriangle);
export default __webpack_public_path__ + "static/media/right-triangle.465891b7.svg";
export { ForwardRef as ReactComponent };